export default __webpack_public_path__ + "static/media/wallet-not-connected-background.62df9cf2.png";